var _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 35,
    viewBox: "0 0 35 35",
    width: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.5 0a17.5 17.5 0 1 1 -17.5 17.5 17.5 17.5 0 0 1 17.5-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 1.5c-4.27375031 0-8.2917099 1.66428947-11.31370926 4.68629074-3.02200127 3.02199936-4.68629074 7.03995895-4.68629074 11.31370926s1.66428947 8.2917099 4.68629074 11.31370926c3.02199936 3.02200127 7.03995895 4.68629074 11.31370926 4.68629074s8.2917099-1.66428947 11.31370926-4.68629074c3.02200127-3.02199936 4.68629074-7.03995895 4.68629074-11.31370926s-1.66428947-8.2917099-4.68629074-11.31370926c-3.02199936-3.02200127-7.03995895-4.68629074-11.31370926-4.68629074m0-1.5c9.66497993 0 17.5 7.83502007 17.5 17.5s-7.83502007 17.5-17.5 17.5-17.5-7.83502007-17.5-17.5 7.83502007-17.5 17.5-17.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    height: 21.792,
    rx: 6,
    stroke: "none",
    width: 21.792,
    x: 6.382,
    y: 6.604
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 19.792,
    rx: 5,
    width: 19.792,
    x: 7.382,
    y: 7.604
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.278,
    cy: 17.5,
    r: 5.613,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.278,
    cy: 17.5,
    fill: "none",
    r: 4.613
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.892,
    cy: 11.887,
    fill: "#fff",
    r: 1.321
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.be5879a2e0d1cfbe23cedca7e37f82cb.svg";
export { ForwardRef as ReactComponent };